import { render, staticRenderFns } from "./building.vue?vue&type=template&id=9f20a396&scoped=true&"
import script from "./building.vue?vue&type=script&lang=js&"
export * from "./building.vue?vue&type=script&lang=js&"
import style0 from "./building.vue?vue&type=style&index=0&id=9f20a396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f20a396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9f20a396', component.options)
    } else {
      api.reload('9f20a396', component.options)
    }
    module.hot.accept("./building.vue?vue&type=template&id=9f20a396&scoped=true&", function () {
      api.rerender('9f20a396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/markers/building.vue"
export default component.exports